export default "__VITE_ASSET__BagHRMKI__";